var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('metabolite-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"threshold":_vm.threshold,"value":_vm.value,"no-data-available-msg":("ANOVA failed. " + _vm.errorMsg)},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }